import { Entity } from '../../../../base/Entity'

import { type model_enum } from '../../../../Foobara/Ai/AnswerBot/Types/model_enum'

export type DynamicCommandPrimaryKeyType = number
export const dynamicCommandPrimaryKeyAttributeName: 'id' = 'id'
export interface DynamicCommandAttributesType {
  id: number
  organization_name?: string
  domain_name?: string
  command_name?: string
  full_name?: string
  description?: string
  inputs_type?: any
  result_type?: any
  default_llm_model?: model_enum
}

export class DynamicCommand<
  AttributesType extends DynamicCommandAttributesType = DynamicCommandAttributesType
> extends Entity<DynamicCommandPrimaryKeyType, AttributesType> {
  static readonly modelName: string = 'DynamicCommand'
  static readonly entityName: string = 'DynamicCommand'
  static readonly primaryKeyAttributeName: 'id' = 'id'

  get id (): DynamicCommandPrimaryKeyType {
    return this.primaryKey
  }

  get associationPropertyPaths (): string[][] { return [] }
  readonly hasAssociations: false = false

  get organization_name (): AttributesType['organization_name'] {
    return this.readAttribute('organization_name')
  }

  get domain_name (): AttributesType['domain_name'] {
    return this.readAttribute('domain_name')
  }

  get command_name (): AttributesType['command_name'] {
    return this.readAttribute('command_name')
  }

  get full_name (): AttributesType['full_name'] {
    return this.readAttribute('full_name')
  }

  get description (): AttributesType['description'] {
    return this.readAttribute('description')
  }

  get inputs_type (): AttributesType['inputs_type'] {
    return this.readAttribute('inputs_type')
  }

  get result_type (): AttributesType['result_type'] {
    return this.readAttribute('result_type')
  }

  get default_llm_model (): AttributesType['default_llm_model'] {
    return this.readAttribute('default_llm_model')
  }
}
